
import { ScrollArea } from '@/components/ui/scroll-area';
import { TabsContent } from '@/components/ui/tabs';
import SectionCard from './SectionCard';
import { AnalysisSection } from './types';

interface TabContentProps {
  value: string;
  sections: AnalysisSection[];
  expandedSections: Set<number>;
  onToggleSection: (index: number) => void;
  baseIndex?: number;
}

export default function TabContent({ 
  value, 
  sections, 
  expandedSections, 
  onToggleSection,
  baseIndex = 0 
}: TabContentProps) {
  return (
    <TabsContent value={value} className="space-y-4">
      {sections.map((section, index) => {
        const sectionIndex = baseIndex + index;
        return (
          <SectionCard 
            key={index} 
            section={section} 
            index={sectionIndex}
            isExpanded={expandedSections.has(sectionIndex)}
            onToggle={() => onToggleSection(sectionIndex)}
          />
        );
      })}
    </TabsContent>
  );
}
